var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExepts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M57.6 13.6842C59.456 13.6842 60.96 14.3684 62.144 15.7026C63.36 17.1053 64 18.6447 64 20.5263V58.1579C64 60.0395 63.36 61.5789 62.144 62.9816C60.96 64.3158 59.456 65 57.6 65H6.4C4.544 65 3.04 64.3158 1.856 62.9816C0.64 61.5789 0 60.0395 0 58.1579V20.5263C0 18.6447 0.64 17.1053 1.856 15.7026C3.04 14.3684 4.544 13.6842 6.4 13.6842H19.2V6.84211C19.2 4.85789 19.84 3.25 21.056 1.98421C22.24 0.68421 23.744 0 25.6 0H38.4C40.256 0 41.76 0.68421 42.944 1.98421C44.16 3.25 44.8 4.85789 44.8 6.84211V13.6842H57.6ZM6.4 20.5263V58.1579H57.6V20.5263H6.4ZM38.4 13.6842V6.84211H25.6V13.6842H38.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExepts);
export default __webpack_public_path__ + "static/media/exepts.e1ae880d769003c411909a85f3cb8c91.svg";
export { ForwardRef as ReactComponent };